module.exports = __webpack_public_path__ + "img/target-icon.22dd902a.svg";